const defaultConfig = {
	Accept: 'application/json',
	'access-control-allow-origin': '*'
}

export const getDefaultConfig = (customHeaders = {}) => ({ headers: { ...defaultConfig, ...customHeaders } })
